module.exports = __webpack_public_path__ + "img/banner-b2@1x.fed9ac7b.jpg";